import { motion } from "framer-motion";

export const MagneticButton = ({ children, className = "", onClick, setHovered }) => (
  <motion.button
    onMouseEnter={() => setHovered(true)}
    onMouseLeave={() => setHovered(false)}
    onClick={onClick}
    whileTap={{ scale: 0.95 }}
    whileHover={{ scale: 1.05 }}
    className={`relative ${className}`}
  >
    {children}
  </motion.button>
);